import React, { Component } from 'react';
import { Field } from 'redux-form';
import * as Form from '../../elements/forms/formFieldHelpers';
import { Buttons } from '../../elements/ui';

class IndustryForm extends Component {
    componentDidMount () {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const { initialize, primary_industry, personId } = this.props;
        const primaryIndustryExists = primary_industry && primary_industry.hasOwnProperty('name'),
            initialValues = {
                "industry": primaryIndustryExists && {label: primary_industry.name, value: primary_industry.id},
                "personId": personId,
                "type": primaryIndustryExists ? "UPDATE" : "CREATE",
            };
        return initialize( initialValues );
    }

    normaliseData = ( formData ) => {
        const { buttonHandlers, industries, personId } = this.props;
            const industryName = industries.find( industry => industry.id === formData.industry.value ).name;
            const normalisedData = {
                personId: personId,
                id: formData.industry.value,
                name: industryName,
                primaryIndustry: 1,
                type: formData.type,
            }
        return buttonHandlers.handleData( normalisedData );
    }

    render() {
        const { handleSubmit, buttonHandlers, industries, primary_industry } = this.props,
            numberButtons = primary_industry && primary_industry.hasOwnProperty('name') && 3;
        return (
            <form className="form-standard-profile" onSubmit={ handleSubmit ( this.normaliseData ) }>
                <Field
                    name="industry"
                    placeholder="Industry"
                    component={ Form.selectField }
                    options={ industries.map( option =>  {
                        return {
                            value: option.id,
                            label: option.name
                        }
                    } ) }
                />
                {/*handleSubmit is passed as undefined as in this case it is the form that is handling the onSubmit */}
                {/*and not the Save button - data needed to be normalised before submitting*/}
                <Buttons.HOCFormButtons
                    { ...this.props }
                    { ...buttonHandlers }
                    handleSubmit={ undefined }
                    numberButtons={ numberButtons }
                />
            </form>
        )
    }
}

export default IndustryForm;




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/IndustryForm.js